import {defineStore} from 'pinia'
import {useShipmentStore} from "./shipment";
import {uuid} from 'vue-uuid';
import {useLoadingStore} from "./loading";

// You can name the return value of `defineStore()` anything you want,
// but it's best to use the name of the store and surround it with `use`
// and `Store` (e.g. `useUserStore`, `useCartStore`, `useProductStore`)
// the first argument is a unique id of the store across your application
export const useOrderStore = defineStore(`order`, {
    state: () => ({
        uuid: null,
        shipments: [],
        drop_off_date: '',
        before_ten: false,
        requested_pickup: false,
        status: '',
        total: null,
        fees: [],
        line_items: [],
        broker: null,
        clientSecret: null,
    }),
    getters: {
        hasSelectedRates: function (state) {
            return state.shipments.find((uuid) => {
                const shipment = useShipmentStore(uuid);
                return !shipment.readyForPurchase;
            }) === undefined;
        },

        readyForPurchase: function (state) {
            return state.shipments.length && this.hasSelectedRates;
        },
        unusedShipments: function (state) {
            return state.shipments.reduce((prev, uuid) => {
                const shipment = useShipmentStore(uuid);
                if (shipment.unused) {
                    prev.push(uuid);
                }
                return prev;
            }, [])
        }
    },

    actions: {
        async fetchOrder(uuid) {
            await axios.get(`/orders/${uuid}`, {headers: {"Accept": "application/json"}}).then(res => {
                const order = res.data.data;
                this.updateOrderStore(order);
            }).catch(err => {
                // todo: handle error
                alert('error fetching order')
            })
        },

        updateOrder() {
            const useLoading = useLoadingStore();
            useLoading.isLoading = true;

            const data = {...this.$state};
            data.shipments = data.shipments.map(shipment => shipment.$state);

            return axios({
                url: '/orders/' + this.uuid,
                method: 'post',
                data: {...data, '_method': 'PUT'},
                headers: {
                    accept: 'application/json',
                },
            }).then(({data}) => {
                this.updateOrderStore(data.data);
            }).catch((error) => {
                if (error?.response?.status === 419) {
                    // csrf expired. need to refresh
                    alert('You will need to refresh this page to generate an estimate')
                    location.reload();
                }

                if (error?.response?.status === 422) {
                    if (error.response?.data?.message) {
                        alert(error.response.data.message);
                    } else {
                        let errors = [];
                        for (const [key, value] of Object.entries(error.response.data)) {
                            value.forEach(err => errors.push(err))
                        }

                        alert(errors.join("\n"));
                    }
                }
            }).finally(() => {
                useLoading.isLoading = false;
            })
        },

        updateShipments: function (shipments) {
            if (shipments.length === 0) {
                return;
            }
            shipments.map(this.addShipment)
            // const currentShipmentIds = this.shipments.map(shipment => shipment.uuid);
            // const newShipments = shipments.filter(shipment => shipment.uuid && !currentShipmentIds.includes(shipment.uuid));
            // newShipments.map(this.addShipment)
        },

        updateOrderStore: function (order) {
            this.updateShipments(order.shipments);

            this.uuid = order.uuid
            this.drop_off_date = order.drop_off_date
            this.before_ten = order.before_ten
            this.requested_pickup = order.requested_pickup
            this.status = order.status
            this.total = order.total
            this.fees = order.fees
            this.line_items = order.line_items
        },

        deleteUnusedShipments(){
           this.unusedShipments.map(this.deleteShipment);
        },

        deleteShipment(shipmentUuid) {
            const useLoading = useLoadingStore();
            useLoading.isLoading = true;

            return axios.post(
                `/orders/${this.uuid}/shipments/${shipmentUuid}`,
                {'_method': 'delete'},
                {
                    headers: {"Accept": "application/json"},
                }
            )
                .then((response) => {
                    this.updateOrderStore(response.data)
                }).catch((error) => {
                    // console.log(error)
                })
                .finally(() => {
                    // this may have been a 404 since they didn't fetch rates yet, so we will just remove it
                    // also our updateOrderStore doesn't actually remove any rates, so we need to do that here
                    this.shipments = this.shipments.filter(uuid => uuid !== shipmentUuid);
                    useLoading.isLoading = false;
                });
        },

        addShipment: function (shipment = {}, parcels = []) {
            const store = useShipmentStore(shipment?.uuid || uuid.v4());
            store.$patch(shipment);

            if (parcels?.length > 0) {
                parcels.map(store.addParcel);
            } else if (!shipment?.parcels?.length) {
                store.addParcel();
            }

            if (!this.shipments.includes(store.uuid)) {
                this.shipments.push(store.uuid);
            }
        },
        getIntent: async function () {
            const useLoading = useLoadingStore();
            useLoading.isLoading = true;

            const response = await axios.post(`/orders/${this.uuid}/intent`, {headers: {"Accept": "application/json"}})
                .finally(() => {
                    useLoading.isLoading = false;
                });

            if (response?.data.status) {
                this.clientSecret = response?.data?.message;
            }
        }
    },
})
